import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Container } from '$views/components/Layout/Container'
import { FormContainer } from '$views/components/FormContainer'

export const StyledAcceptedCardImage = styled.img`
  height: ${rem(60)};
`

export const PaymentGreyBlock = styled.div`
  background-color: ${p => p.theme.colors.xlightGrey};
  position: relative;
  top: 3rem;
  width: 100%;
  ${p => p.theme.media.desktop`top:4.5rem`};
`

export const ContainerPaymentGreyBlock = styled.div`
  max-width: 25rem;
  margin: auto;
  padding: ${p => rem(p.theme.sizes.mini)} 0;
  ${p => p.theme.media.onlyMobile`
    padding: ${rem(p.theme.sizes.mini)} ${rem(p.theme.sizes.mini)};
  `}
`

export const StyledSelectedPlanContainer = styled(Container)`
  padding-top: ${p => rem(p.theme.sizes.small)};
  margin-bottom: 3.5rem;
  ${p => p.theme.media.desktop`
    padding-top: ${rem(p.theme.sizes.medium)};
    margin-bottom: 5rem;
  `};
`

export const StyledSelectedPlanFormContainer = styled(FormContainer)`
  margin-top: 0;
`

export const StyledIncludedPlanContainer = styled(Container)`
  top: 0;
  margin-bottom: 0;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: ${p => rem(p.theme.sizes.large)};
`



// WEBPACK FOOTER //
// ./src/views/Premium/PremiumCustomerPayment/PremiumCustomerPayment.style.ts